import React from 'react';
import './App.css';
import Toggle from './Toggle';
import Home from './components/Home';
import Projects from './components/Projects';
import Contact from './components/Contact'
import Technology from './components/Technologies'
import { BackgroundProvider, useBackground } from './BackgroundContext';
import Cursor from './components/Cursor';
import Music from './components/Music'

// Create a wrapper component to access the context
function AppContent() {
  const { theme } = useBackground(); // Use the context here
  
  return (
    <div>
      <Toggle />
      <Cursor />
    <div
      className="App"
      style={{
        backgroundColor: theme.background, // Set background color from theme
        color: theme.fontColor, // Set font color from theme
      }}>
      <Home />
      <Projects />
      <Technology />
      <Music />
      <Contact />
    </div>
        </div>
  );
}

function App() {
  return (
    <BackgroundProvider>
      <AppContent /> {/* Render the content inside the provider */}
    </BackgroundProvider>
  );
}

export default App;